var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888 36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18Z",
    fill: "#F4F2FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2501 12.7579C22.9251 12.4329 22.4001 12.4329 22.0751 12.7579L18.0001 16.8246L13.9251 12.7496C13.6001 12.4246 13.0751 12.4246 12.7501 12.7496C12.4251 13.0746 12.4251 13.5996 12.7501 13.9246L16.8251 17.9996L12.7501 22.0746C12.4251 22.3996 12.4251 22.9246 12.7501 23.2496C13.0751 23.5746 13.6001 23.5746 13.9251 23.2496L18.0001 19.1746L22.0751 23.2496C22.4001 23.5746 22.9251 23.5746 23.2501 23.2496C23.5751 22.9246 23.5751 22.3996 23.2501 22.0746L19.1751 17.9996L23.2501 13.9246C23.5668 13.6079 23.5668 13.0746 23.2501 12.7579Z",
    fill: "#8475DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosex);
export default __webpack_public_path__ + "static/media/closex.f93595161743d2b54cad7c9e7d920128.svg";
export { ForwardRef as ReactComponent };